export default "__VITE_ASSET__33d98565__"